import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WaitlistForm } from './WaitlistForm';

export function WaitingListPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showSuccess, setShowSuccess] = useState(false);
  
  // Get course type from URL parameter, default to 'advanced'
  const courseType = (searchParams.get('type') || 'advanced') as 'advanced' | 'premium';

  const handleSuccess = () => {
    setShowSuccess(true);
    // Redirect to landing page after 2 seconds
    setTimeout(() => {
      navigate('/');
    }, 2000);
  };

  const handleClose = () => {
    // If form is closed, redirect to landing page
    navigate('/');
  };

  if (showSuccess) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '3rem',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: '#4CAF50',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem'
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
          </div>
          <h2 style={{
            margin: '0 0 1rem',
            color: 'var(--dark)',
            fontFamily: 'var(--montserrat)',
            fontSize: '1.5rem'
          }}>
            You're on the waitlist!
          </h2>
          <p style={{
            margin: '0 0 1.5rem',
            color: 'var(--gray)',
            fontFamily: 'var(--montserrat)',
            fontSize: '1rem'
          }}>
            Thank you for your interest! We'll notify you as soon as the course becomes available.
          </p>
          <p style={{
            margin: 0,
            color: 'var(--gray)',
            fontFamily: 'var(--montserrat)',
            fontSize: '0.875rem'
          }}>
            Redirecting to homepage...
          </p>
        </div>
      </div>
    );
  }

  return (
    <WaitlistForm
      courseType={courseType}
      onClose={handleClose}
      onSuccess={handleSuccess}
    />
  );
}

